import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const legalEntityApi = createApi({
    reducerPath: "base/legalEntity",
    baseQuery: axiosBaseQuery,
    tagTypes: ["legalEntityList"],
    endpoints: (builder) => ({
        legalEntityFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['legalEntityList'],
            query: (query = '') => ({
                url: "/base/legalEntity" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        legalEntityCreate: builder.mutation({
            invalidatesTags: ['legalEntityList'],
            query: (data) => ({ url: "/base/legalEntity", method: "POST", data })
        }),
        legalEntityUpdate: builder.mutation({
            invalidatesTags: ['legalEntityList'],
            query: (data) => ({ url: "/base/legalEntity/" + data.id, method: "PUT", data })
        }),
        legalEntityDelete: builder.mutation({
            invalidatesTags: ['legalEntityList'],
            query: (id) => ({ url: "/base/legalEntity/" + id, method: "DELETE" })
        }),
    })
})

export const { useLegalEntityFindAllQuery, useLegalEntityCreateMutation, useLegalEntityUpdateMutation, useLegalEntityDeleteMutation } = legalEntityApi;
export { legalEntityApi };
